import { routes } from "../../../app/routes";
import { IconDefinitions } from "../../icons";
import logo from "../../../images/branding/logo-blue.svg";

export const useCommonItems = () => [
  {
    text: "Home",
    url: routes.home,
    image: logo,
    className: "lh-1",
    activeMatchUrl: routes.home,
  },
  {
    text: "My Profile",
    url: routes.profile.index,
    icon: IconDefinitions.user,
    activeMatchUrl: [routes.profile.index, routes.profile.changePassword],
  },
  {
    text: "Calendar",
    url: routes.calendar.index,
    icon: IconDefinitions.calendar,
    activeMatchUrl: [routes.calendar.index, routes.calendar.location],
  },
  {
    text: "Appointments",
    url: routes.appointments.index,
    icon: IconDefinitions.clipboard,
    activeMatchUrl: [routes.appointments.index],
  },
];

export default useCommonItems;
